import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  ocrLoading: {},
  ocrData: {},
  ocrError: {}
};

export default handleActions(
  {
    SET_OCR_DATA_LOADING: (state, { payload: { key, isLoading } }) => ({
      ...state,
      ocrLoading: {
        ...state.ocrLoading,
        [key]: isLoading
      }
    }),
    SET_OCR_DATA: (state, { payload: { key, data } }) => ({
      ...state,
      ocrData: {
        ...state.ocrData,
        [key]: data
      }
    }),
    SET_OCR_ERROR: (state, { payload: { key, error, id } }) => ({
      ...state,
      ocrLoading: {
        ...state.ocrLoading,
        [key]: false
      },
      ocrData: {
        ...state.ocrData,
        [key]: ""
      },
      ocrError: {
        ...state.ocrError,
        [id]: { key, error }
      }
    }),
    RESET_OCR_STATES: () => initialState
  },
  initialState
);
